module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/price-letter-ed13811936b34e6339589c95b780bf68.svg";